<template>
<footer class="footer">
    <div class="container">
        <div class="footer__top">
            <nav class="footer__nav">
                <ul class="footer__menu">
                    <li class="footer__menu-list">
                        <router-link :to="{name: 'contact'}">
                            <a href="/contact" class="footer__menu-link">Контакты</a>
                        </router-link>
                    </li>
                    <li class="footer__menu-list">
                        <router-link :to="{name: 'frequently'}">
                            <a href="#" class="footer__menu-link">Часто задаваемые вопросы</a>
                        </router-link>
                    </li>
                    <li class="footer__menu-list">
                        <router-link :to="{name: 'rules'}">
                            <a href="#" class="footer__menu-link">Правила и условия</a>
                        </router-link>
                    </li>
                    <li class="footer__menu-list">
                        <div class="footer__menu-social">
                            <a href="" target="_blank"><img src="/img/icon-facebook.svg" alt="" /></a>
                            <a href="" target="_blank"><img src="/img/icon-instagram.svg" alt="" /></a>
                            <a href="" target="_blank"><img src="/img/icon-youtube.svg" alt="" /></a>
                        </div>
                    </li>
                </ul>
            </nav>
        </div>
        <div class="footer__bottom">
            <p class="footer__bottom-text">
                © 2020. Все права защищены. Копирование материала с этого сайта
                возможно только с разрешения правообладателя и с размещением ссылки на
                первоисточник.
            </p>
        </div>
    </div>
    <div class="footer__bottom-bg"></div>
</footer>
</template>

<script>
export default {
    name: "footer",
};
</script>

<style>
.footer {
    background: #02120b;
    position: relative;
}

.footer .container {
    padding: 0 40px;
}

footer:before {
    content: "";
    left: 0;
    top: 94px;
    position: absolute;
    width: 100%;
    height: 0.2px;
    background: #ffffff;
}

.footer__top {
    padding: 38px 0 25px 0;
}

.footer__bottom {
    padding: 9px 0 15px 0;
}

.footer__menu {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.footer__menu-link {
    font-family: "Roboto-Regular";
    font-size: 14px;
    line-height: 16px;
    text-transform: capitalize;
    color: #fff599;
    text-decoration-line: underline;
}

.footer__menu-social a {
    margin-left: 8px;
}

.footer__bottom-bg {
    height: 24px;
    background: linear-gradient(180deg, #000000 0%, rgba(255, 255, 255, 0) 100%),
        #000000;
}

.footer__bottom-text {
    font-size: 12px;
    line-height: 14px;
    text-align: center;
    font-family: "Roboto-Light";
}

@media (max-width: 1000px) {
    .footer__bottom-bg {
        display: none;
    }

    .main__question-1 .main__question-bg-2 {
        left: -4%;
        bottom: -38%;
    }
}

@media (max-width: 600px) {
    .footer__menu {
        flex-wrap: wrap;
    }
    .footer__menu-list {
        margin: 10px 5px;
    }
    .footer__top {
        padding: 10px 0;
    }
    .footer:before {
        top: 109px !important;
    }
    .footer__menu-link {
        font-size: 12px;
    }
    .footer .container {
        padding: 0 13px;
    }
    .footer__bottom-text {
        font-size: 11px;
    }
}
</style>
